import type { InputState } from '../core/types';

// Physical-key → action(s). Uses event.code so it's layout-independent. ArrowUp/W drive
// both jump (in-game) and up (menus); ArrowDown/S drive down; Escape is "back".
const KEYMAP: Record<string, (keyof InputState)[]> = {
  ArrowLeft: ['left'],
  KeyA: ['left'],
  ArrowRight: ['right'],
  KeyD: ['right'],
  Space: ['jump'],
  ArrowUp: ['jump', 'up'],
  KeyW: ['jump', 'up'],
  ArrowDown: ['down'],
  KeyS: ['down'],
  ShiftLeft: ['dash'],
  ShiftRight: ['dash'],
  KeyJ: ['dash'],
  Escape: ['back'],
};

export interface Keyboard {
  readonly state: InputState;
  detach(): void;
}

export function createKeyboard(target: Window = window): Keyboard {
  const state: InputState = {
    left: false,
    right: false,
    jump: false,
    dash: false,
    up: false,
    down: false,
    back: false,
  };

  const handle = (down: boolean) => (e: KeyboardEvent): void => {
    const actions = KEYMAP[e.code];
    if (actions) {
      for (const a of actions) state[a] = down;
      e.preventDefault();
    }
  };
  const onDown = handle(true);
  const onUp = handle(false);
  target.addEventListener('keydown', onDown);
  target.addEventListener('keyup', onUp);

  return {
    state,
    detach() {
      target.removeEventListener('keydown', onDown);
      target.removeEventListener('keyup', onUp);
    },
  };
}
